import { Box } from '@deity/falcon-ui';
import { Select } from '@deity-io/portal-ui';
import type { FC } from 'react';

interface IHostProps {
  protocol: string;
  isEditable: boolean;
  onChange: (path: string[], val: string) => void;
}
export const Protocol: FC<IHostProps> = ({ isEditable, protocol, onChange }) => (
  <Box style={{ width: '50%' }}>
    <Select
      label="Protocol"
      sx={{ marginY: 1 }}
      onChange={(val: any) => onChange(['protocol'], val?.value)}
      options={['http', 'https']?.map(p => ({
        value: p,
        label: p.toUpperCase()
      }))}
      value={{ label: protocol?.toUpperCase(), value: protocol }}
      disabled={!isEditable}
      autoComplete={false}
      disableClearable
    />
  </Box>
);
